'use client';

import { useSiteSettingsContext } from '../contexts/site-settings-context';
import getLocale from '../getters/get-locale';

const useCurrencyFormatter = () => {
  const locale = getLocale();
  const { localization } = useSiteSettingsContext();

  const handleFormat = (amount: number) => {
    const isWholeNumber = amount % 1 === 0;

    return new Intl.NumberFormat(locale, {
      currency: localization?.regionInfo.isoCurrencySymbol || 'DKK',
      maximumFractionDigits: 2,
      minimumFractionDigits: isWholeNumber ? 0 : 2,
      style: 'currency',
    }).format(amount);
  };

  return handleFormat;
};

export default useCurrencyFormatter;
